import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  return (
    <footer className="main-footer">
      <div className="footer-cards-container">
        {/* Contact Card */}
        <div 
          className={`footer-card contact-card ${hoveredCard === 0 ? 'hovered' : ''} ${hoveredCard !== null && hoveredCard !== 0 ? 'dimmed' : ''}`}
          onMouseEnter={() => setHoveredCard(0)}
          onMouseLeave={() => setHoveredCard(null)}
        >
          <div className="card-content">
            <div className="card-logo">
              <div className="dmb-logo-footer">
                <span>dmb</span>
              </div>
            </div>
            
            <div className="card-info">
              <h3>contact</h3>
              <div className="contact-details">
                <p>79 waterworks road</p>
                <p>worcester</p>
                <p>WR1 3EZ</p>
                <div className="contact-separator"></div>
                <p>01905 616006</p>
                <p>sales@dmbrands.co.uk</p>
              </div>
            </div>
          </div>
        </div>

        {/* Links Card */}
        <div 
          className={`footer-card links-card ${hoveredCard === 1 ? 'hovered' : ''} ${hoveredCard !== null && hoveredCard !== 1 ? 'dimmed' : ''}`}
          onMouseEnter={() => setHoveredCard(1)}
          onMouseLeave={() => setHoveredCard(null)}
        >
          <div className="card-content">
            <div className="links-grid">
              <div 
                className="link-item privacy"
                onClick={() => handleNavigation('/privacy')}
              >
                <span className="link-dot blue"></span>
                <span>privacy policy</span>
              </div>
              <div 
                className="link-item terms"
                onClick={() => handleNavigation('/terms')}
              >
                <span className="link-dot teal"></span>
                <span>terms & conditions</span>
              </div>
              <div 
                className="link-item cookies"
                onClick={() => handleNavigation('/cookies')}
              >
                <span className="link-dot yellow"></span>
                <span>cookies</span>
              </div>
              <div 
                className="link-item contact-us"
                onClick={() => handleNavigation('/contact')}
              >
                <span className="link-dot orange"></span>
                <span>contact us</span>
              </div>
              <div 
                className="link-item support"
                onClick={() => handleNavigation('/support')}
              >
                <span className="link-dot purple"></span>
                <span>support</span>
              </div>
              <div 
                className="link-item about"
                onClick={() => handleNavigation('/about')}
              >
                <span className="link-dot green"></span>
                <span>about us</span>
              </div>
            </div>
          </div>
        </div>

        {/* Brands Card */}
        <div 
          className={`footer-card brands-card ${hoveredCard === 2 ? 'hovered' : ''} ${hoveredCard !== null && hoveredCard !== 2 ? 'dimmed' : ''}`}
          onMouseEnter={() => setHoveredCard(2)}
          onMouseLeave={() => setHoveredCard(null)}
        >
          <div className="card-content">
            <h3>brands</h3>
            <div className="brands-list">
              <div className="brand-name" onClick={() => handleNavigation('/brand/elvang')}>Elvang</div>
              <div className="brand-name" onClick={() => handleNavigation('/brand/gefu')}>Gefu</div>
              <div className="brand-name" onClick={() => handleNavigation('/brand/remember')}>Remember</div>
              <div className="brand-name" onClick={() => handleNavigation('/brand/rader')}>Rader</div>
              <div className="brand-name" onClick={() => handleNavigation('/brand/ppd')}>PPD</div>
              <div className="brand-name" onClick={() => handleNavigation('/brand/relaxound')}>Relaxound</div>
              <div className="brand-name" onClick={() => handleNavigation('/brand/myflame')}>My Flame</div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;